import { TagFormElement } from './TagFormElement';

export class TagFormElementText extends TagFormElement {
    public readonly name: string;

    public constructor({id = "", name = "", type = "", sortOrder = 0}) {
      super(id, sortOrder, type, "io.indexed.domainmodel.tagging.TagFormElementText");

      this.name = name;
    }
}
